import { useQuery } from '@tanstack/react-query'
import {
	type GetMMSubmissionsParams,
	httpGetMMSubmissions
} from '@/features/luxe-submissions/http/luxe-submissions.http'

export const MM_SUBMISSIONS_QUERY_KEY = 'mm-submissions'

export const useGetMMSubmissions = (params: GetMMSubmissionsParams = {}) =>
	useQuery({
		queryKey: [MM_SUBMISSIONS_QUERY_KEY, params],
		queryFn: () => httpGetMMSubmissions(params)
	})
